<h1 mat-dialog-title>{{data.label}}</h1>
<form [formGroup]="form">
    <div mat-dialog-content class="content">

        <div *ngFor="let field of this.data.fields">
            <div class="row">
                <mat-form-field appearance="outline" class="col-md-12">
                    <mat-label>{{ field.label }}</mat-label>
                    <input *ngIf="field.type === 'text'" [type]="field.type" [readonly]="field.readonly"
                        [value]="field.default_value" matInput [formControlName]="field.name"
                        [placeholder]="field.placeholder">

                    <input *ngIf="field.type === 'number'" [type]="field.type" [readonly]="field.readonly"
                        [value]="field.default_value" matInput [formControlName]="field.name"
                        [placeholder]="field.placeholder">

                    <input *ngIf="field.type === 'password'" [type]="field.type" [value]="field.default_value" matInput
                        [formControlName]="field.name" [placeholder]="field.placeholder">
                    <textarea *ngIf="field.type === 'textarea'" matInput [formControlName]="field.name"
                        [value]="field.default_value" [placeholder]="field.placeholder"></textarea>
                    <mat-select *ngIf="field.type === 'select'" [disabled]="field.readonly"
                        [formControlName]="field.name" [value]="field.default_value">
                        <mat-option *ngFor="let option of field.options" [value]="option.value">{{ option.label
                            }}</mat-option>
                    </mat-select>
                    <mat-checkbox *ngIf="field.type === 'checkbox'" [formControlName]="field.name">{{
                        field.label}}</mat-checkbox>
                    <mat-radio-group *ngIf="field.type === 'radio'" [formControlName]="field.name">
                        <mat-radio-button *ngFor="let option of field.options" [value]="option.value">{{ option.label
                            }}</mat-radio-button>
                    </mat-radio-group>

                    <!--A revoir. Si add, on rajoute l'icon de datepicker, si update, on laisse comme ça-->

                    <ng-container *ngIf="data.type === 'update' && field.type === 'date'">
                        <input *ngIf="field.type === 'date'" matInput [formControlName]="field.name"
                            [value]="field.default_value">
                    </ng-container>


                    <ng-container *ngIf="data.type === 'add' && field.type === 'date'">
                        <input *ngIf="field.type === 'date'" [matDatepicker]="picker" matInput
                            [formControlName]="field.name" [value]="field.default_value">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </ng-container>

                    <ng-container *ngIf="field.type === 'file'">
                        <div class="col-md-10">
                            <input type="file" #fileInput (change)="onFileSelected($event)" style="display: none" />
                            <input matInput [value]="selectedFileName" readonly
                                matTooltip="Cliquez pour selectionner un fichier" />
                        </div>
                        <button class="col-md-2" (click)="fileInput.click()" mat-fab color="primary"
                            aria-label="Choisir un fichier">
                            <mat-icon>bookmark</mat-icon>
                        </button>
                    </ng-container>

                    <ng-container *ngIf="field.type == 'matAutoComplete'">

                        <input type="text" matInput [formControl]="myControl" [matAutocomplete]="autoCarton">
                        <mat-autocomplete #autoCarton="matAutocomplete" [displayWith]="displayFn"
                            (optionSelected)="onSelected($event)">
                            <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                                {{ option.label }}
                            </mat-option>
                        </mat-autocomplete>
                    </ng-container>

                </mat-form-field>
            </div>
        </div>
    </div>
    <div mat-dialog-actions class="action">
        <button mat-raised-button type="button" mat-dialog-close>Annuler</button>
        <button mat-raised-button class="btn btn-dark text-white" (click)="onSubmit()" [disabled]="!form.valid">
            <ng-container *ngIf="data.type === 'add'; else updateLabel">
                ENREGISTRER
            </ng-container>
            <ng-template #updateLabel>
                MODIFIER
            </ng-template>
        </button>
    </div>
</form>